import type {EmptyPayload} from 'constants/events/EventPayloadUtils';
import type {StringIDFolder} from 'constants/FolderConstants';
import type {SidepanelSection} from 'constants/NavConstants';
import type {Section as SidebarSection} from 'sidebar/SidebarConstants';

export const NAV_EVENT_PAYLOADS = {
  SIDEBAR_OPEN: {} as {
    section?: SidebarSection | null;
  },
  SIDEBAR_CLOSE: {} as {},
  SIDEBAR_OPEN_FOR_FILE_TYPE: {} as {
    fileType: string | null;
  },

  OPEN_SIDEPANEL_WITH_SECTION: {} as {
    section?: SidepanelSection;
  },
  SET_SIDEPANEL_CLOSED: {} as {},
  SET_SIDEPANEL_COLLAPSED: {} as {},
  SET_SIDEPANEL_SEMI_EXPANDED: {} as {
    section?: SidepanelSection;
  },
  SET_SIDEPANEL_FULLY_EXPANDED: {} as {
    section?: SidepanelSection;
  },
  SET_SIDEPANEL_SECTION: {} as {
    section?: SidepanelSection;
  },
  SIDEPANEL_OPEN_CREATE_MENU: {} as {},
  SIDEPANEL_CLOSE_CREATE_MENU: {} as {},
  SIDEPANEL_OPEN_OVERFLOW_MENU: {} as {},
  SIDEPANEL_CLOSE_OVERFLOW_MENU: {} as {},
  SIDEPANEL_LIST_ALL_SOURCES: {} as {
    section: SidepanelSection;
  },
  SIDEPANEL_LIST_SINGLE_SOURCE: {} as {
    section: SidepanelSection;
    folder: StringIDFolder;
  },
  STORABLES_SIDEPANEL_SET_ACTIVE_REGISTRY: {} as {
    registryId: string | null;
  },

  HIDE_FULL_SCREEN: {} as EmptyPayload,
  SHOW_FULL_SCREEN: {} as {
    screen: string;
  },

  WORKSPACE_WIDTH_UPDATED: {} as {
    workspaceWidth: number;
  },
} as const;

export type NavEventPayload = typeof NAV_EVENT_PAYLOADS;
